import { useEffect, useRef } from 'react';
export const useUnmountLifecycle = callback => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => () => callbackRef.current(), []);
};